import { defineStore } from 'pinia';
import { useApi } from '~/composables/api';
import { API_PROPERTY_MANAGER_000 } from '~/constants/property_manager/api-property-manager-000';

type ApiResponse<T> = Promise<T>;

type MenuList = any;
type HeaderInfo = any;
type UpdateFavorite = any;
type PropertyId = string;

type Prop000State = {
  menuList: MenuList | null;
  headerInfo: HeaderInfo | null;
  updateFavorite: UpdateFavorite | null;
  propertyId: PropertyId | null;
};

export const useProp000Store = defineStore('prop-000', {
  state: (): Prop000State => ({
    propertyId: null,
    menuList: null,
    headerInfo: null,
    updateFavorite: null,
  }),

  getters: {
    getMenuList: (state): MenuList | null => state.menuList,
    getHeaderInfo: (state): HeaderInfo | null => state.headerInfo,
    GetUpdateFavorite: (state): UpdateFavorite | null => state.updateFavorite,
    GetPropertyId: (state): PropertyId | null => state.propertyId,
  },

  actions: {
    fetchPropertyId(){
      const propertyId = localStorage.getItem(API_PROPERTY_MANAGER_000.PROPERTY_ID);
      if (propertyId) {
        this.propertyId = propertyId;
      }
    },

    async fetchMenuList(params: object): ApiResponse<MenuList> {
      this.menuList = await useApi.post(API_PROPERTY_MANAGER_000.PROP_API_000_001, params);
    },

    async fetchHeaderInfo(params: object): ApiResponse<HeaderInfo> {
      this.headerInfo = await useApi.post(API_PROPERTY_MANAGER_000.PROP_API_000_002, params);
    },

    async fetchUpdateFavorite(params: object): ApiResponse<UpdateFavorite> {
      this.updateFavorite = await useApi.post(API_PROPERTY_MANAGER_000.PROP_API_000_003, params);
    },
  }
});
